import { useRef } from "react";
import { Box, Button, Group, Stack } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import { useReactToPrint } from "react-to-print";
import { salesOrderApi } from "apis/salesOrderApi";
import { SalesOrderResponseType } from "constants/types/salesOrder";
import SalesOrderPrintTemplate from "./components/SalesOrderPrintTemplate/SalesOrderPrintTemplate";
import { PAGE_STYLE } from "constants/common/salesOrder";

interface Props {
  salesOrder: SalesOrderResponseType;
}

const SalesOrderPrintContent = ({ salesOrder }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `phieu-ban-hang-${salesOrder.code}`,
    pageStyle: PAGE_STYLE,
  });

  const handlePrintClick = () => {
    handlePrint();
    salesOrderApi.updatePrintStatus(salesOrder.id);
  };

  return (
    <Stack gap="sm">
      <Group justify="flex-end">
        <Button
          leftSection={<IconPrinter size={16} />}
          onClick={handlePrintClick}
        >
          In phiếu
        </Button>
      </Group>

      <Box
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          backgroundColor: "#f0f0f0",
          padding: 16,
          borderRadius: 4,
        }}
      >
        <Box
          style={{
            maxWidth: 794,
            margin: "0 auto",
            backgroundColor: "#ffffff",
            padding: "30px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <SalesOrderPrintTemplate ref={contentRef} salesOrder={salesOrder} />
        </Box>
      </Box>
    </Stack>
  );
};

export default SalesOrderPrintContent;
